/*
    config
*/


/****** GLOBAL: Signage 識別 ******/

// pathname の先頭のディレクトリ名が 'furusato' 以外はサイネージ表示とみなす
var IS_SIGNAGE = ( location.pathname.split('/')[1] !== 'furusato');
if(IS_SIGNAGE){
    console.log('VIEW SIGNAGE !');
}

//ブラウザ判定
function browserJudges() {
  var result = '';
  var ua = navigator.userAgent.toLowerCase();
  var ver = navigator.appVersion.toLowerCase();

  // IE(11以外)
  var isMSIE = (ua.indexOf('msie') > -1) && (ua.indexOf('opera') == -1);

  if (isMSIE && (ver.indexOf('msie 10.') > -1)) {
    result = 'IE10';  // IE10
  } else if (ua.indexOf("trident/7") > -1) {
    result = 'IE11';  // IE11
  } else if (ua.indexOf("edge") > -1) {
    result = 'Edge'; // Edge
  } else if (ua.indexOf('chrome') > -1) {
    result = 'Chrome'; // Google Chrome
  } else if (ua.indexOf('safari') > -1) {
    result = 'Safari';  // Safari
  } else if (ua.indexOf("opera") > -1) {
    result = 'Opera'; // Opera
  } else if (ua.indexOf("firefox") > -1) {
    result = 'Firefox'; // Firefox
  }

  return result;
}

function osJudges() {
  var result = '';
  var ua = navigator.userAgent;

  if(ua.indexOf('iPhone') > 0) {
    result = 'iPhone';
  }

  return result;
}

var checkBrowser = browserJudges();

//Edgeの判別
if (checkBrowser == 'Edge') {
  document.write('<style>ul{list-style: none;}</style>');
}

/**
 * fontSetting.js
 * 
 *  ボタン画像を選択して『設定』ボタン押下 
 *    ... <body>のdata-font属性に idDefault, idLarge, idMax がセット
 */

var defaultFontSize = 87.5;
var defaultid = 'idDefault'; // idDefault, idLarge, idMax
var cookieFont;

//fontSize
function setPropDataFont(fontId) {
  $('body').attr('data-font','');
  $('body').attr('data-font', $('#' + fontId).attr('id'));
  $.cookie('fontSize', fontId, { expires: 365, path: "/" });
}

function setCookieFontSize() {
  cookieFont = $.cookie("fontSize");
  if (cookieFont && cookieFont !== defaultid) {
    $('#' + cookieFont).prop('checked', true);
    $('body').attr('data-font', $('#' + cookieFont).attr('id'));
  }
}

//font変更
function initFontSettingBtnEvent() {
  $('.js-btnSet').on('click', function(){
    //font
    currentId = $('input[name="fsList"]:checked').attr('id');
    setPropDataFont(currentId);
  });

  $('.js-btnBack').on('click', function(){
    //font
    currentId = 'idDefault';
    setPropDataFont(currentId);
    $('#' + currentId).prop('checked', true);
  });

  $('.p-fontModal .btn').on('click', function(){
    
  });

}


$(function(){
  setCookieFontSize();
  initFontSettingBtnEvent();
});


// //File Size get
// function fileSize() {
//   $('.l-main__middle a[href]').each(function () {
//     var $this = $(this);
//     var href = $this.attr('href');

//     if (!$this.hasClass('js-fileSizeNone')) {
//       if (href.match(/\.(PDF|DOC|DOCX|XLS|XLSX|PPT|PPTX|ZIP)$/i)) {
//         var file_size = $.ajax({
//           type: "HEAD",
//           url: href,
//           cache: false
//         }).done(function () {
//           /* success */
//           var hrefLength = href.length;
//           var dotted = href.lastIndexOf(".");
//           var sExtension = href.substring(dotted + 1, hrefLength);
//           sExtension = sExtension.toUpperCase();
//           var filesize = formatFileSize(file_size.getResponseHeader("Content-Length"));

//           var sizeText = '（' + sExtension + '：' + filesize + '）';

//           if ($this.hasClass('c-reportList__link')) {
//             $this.find('.c-report__pdf__text').append('<span class="u-fwNormal">（' + filesize + '）</span>');
//           } else if ($this.hasClass('c-newsList__link')) {
//             $this.find('.c-newsList__text').append(sizeText);
//           } else {
//             $this.append(sizeText);
//           }

//         }).fail(function () {
//           /* error */
//           console.log('error');
//         });
//       }
//     }
//   });

//   function formatFileSize(size) {
//     var unit = [' Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
//     for (var i = 1; i < unit.length; i++) {
//       if (size < Math.pow(1024, i)) return (Math.round((size / Math.pow(1024, i - 1)) * 1) / 1) + unit[i - 1];
//     }
//     return size;
//   }
// }

//高さを揃える
function heightLine() {
  $('.boxHeight').matchHeight();
}


// //アコーディオン
// function accordion() {
//   // 初期化処理
//   $('.js-accordion').off('click', '.js-accordion__head');

//   $('.js-accordion').on('click', '.js-accordion__head', function(e) {
//     var $accordion = $(this).closest('.js-accordion');
//     if (!$accordion.hasClass('open')) {
//       $accordion.addClass('open').children('.js-accordion__body').stop().slideDown();
//     } else {
//       $accordion.children('.js-accordion__body').stop().slideUp(function(){
//         $accordion.removeClass('open');
//       });
//     }
//     return false;
//   });

//   //アコーディオンの展開
//   var getURL = location.href;
//   if ( getURL.indexOf('?q=') === -1) {
//     var URLID = getURL.split('#');
//     if(URLID[1]) {
//       var $getID = '#' + URLID[1];
//       if($($getID).is('.accordion')) {
//         $($getID).addClass('open');
//         $($getID).children('.js-accordion__body').show();
//       }
//     }
//   }
// }

//slider
function commonSlider() {
  var $fSlider = $('.js-fslider');
  $fSlider.slick({
    autoplay: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
      responsive: [
      {
        breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 1
          }
      }]
  });

  
  //dotsにストップボタンの追加
  function stopBtn() {
    $('.js-fslider .slick-dots').append('<li class="stopBtn"><a href="javascript: void(0);">stop</a></li>');
    slideStop();  //ストップボタンをクリックした時の挙動
  }

  // レスポンシブ時にストップボタンの再生成
  $fSlider.on('breakpoint', function(event, slick, breakpoint){
    stopBtn();
  });

  //ストップボタンの生成
  stopBtn();
}

function slideStop() {
  var playFlg = true;

  $('.stopBtn a').on('click', function() {
    if(playFlg) {
      $(this).addClass('is-active');
      $(this).closest('.slick-slider').slick('slickPause');  //スライダーストップ
      playFlg = false;
    } else {
      $(this).removeClass('is-active');
      $(this).closest('.slick-slider').slick('slickPlay');  //スライダー再開
      playFlg = true;
    }
  });
}

//スムーススクロール
function pageScroll() {
  // var not = ':not(.js-modalInline):not(.js-eventModal)';
  var not = '';
  $('a.js-smoothScroll[href^="#"]' + not).on('click', function () {
    var hrefStr = $(this).attr("href");
    if( hrefStr === '#' || ! $(hrefStr) || ! $(hrefStr).offset() ){
      return;
    }
    var offsetTop = $(hrefStr).offset().top;

    if( isSpScreen() ){
      offsetTop = offsetTop - 70; // SPヘッダの高さ
    }

    $("html,body").animate({ scrollTop: offsetTop }, "slow", "swing");
    return false;
  });
}

//ページトップへ戻るボタンのアニメーション
function returnTop() {
  var $pageTop = $('.js-return');
  $pageTop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 300) {
      $pageTop.fadeIn();
    } else {
      $pageTop.fadeOut();
    }
  });
}

// スマフォ表示を判定
function isSpScreen (){
  return window.matchMedia('screen and (max-width:767px)').matches;
}

$(function(){
//  fileSize(); //ファイルサイズ取得
  heightLine(); //高さを揃える
//  accordion(); //アコーディオン
  pageScroll(); //スムーススクロール
  returnTop(); //ページトップへ戻るボタンのアニメーション


  if ($('.js-fslider').length > 0) {
    commonSlider(); //フッターのスライダー
  }

  $('table').responsiveTable();
});

/* table */
(function($){
  $.fn.responsiveTable = function(config){
    var defaults = {
      // captionText: 'スクロールしてご確認ください。',
      size: 1
    };

    var options = $.extend(defaults, config);
    return this.each(function(){
      var $this = $(this);
      var $cells = $this.find('tr:first > *');
      var table_size = $this.find('tr:first > *').length;

      for (var i = 0; i < $cells.length; i++) {
        var $cell = $cells.eq(i);
        var colspan = $cell.attr('colspan');

        if ( colspan ) {
          table_size = table_size + ( colspan - 1 );
        }
      }

      if ( table_size > options.size || $this.is('.sp-scrollTable') ) {
        $this.wrap('<div class="c-tableWrapper"></div>');

        var $wrapper = $this.closest('.c-tableWrapper');
        $wrapper.before('<p class="c-tableCaption"><span>スクロールしてご確認ください。</span></p>');

      }
    });
  };
})(jQuery);

// youtube_player.js --------------------------------------------------


/*
    youtube_player
      --- YouTubeIframe API の都合があるので global scope に配置してます
*/

// プレイヤーを読み込むIDを指定(#不要)
var YTMOVIE_TOPPAGE_PLAYER_ID = 'js-ytmovie-toppage'; // トップページ
var YTMOVIE_PREF_PLAYER_ID = 'js-ytmovie-pref';       // 都道府県ページ

// 動画のループ回数上限
var YTMOVIE_LOOP_LIMIT_NUM = 999; 

// iframe用の YouTube Player API を非同期でロード
var yt_script_tag = document.createElement('script');
yt_script_tag.src = "https://www.youtube.com/iframe_api";
var yt_firstScriptTag = document.getElementsByTagName('script')[0];
yt_firstScriptTag.parentNode.insertBefore(yt_script_tag, yt_firstScriptTag);

// 作業変数
var yt_player;

// callback: プレーヤー API 用の JavaScript のダウンロードが完了時
function onYouTubeIframeAPIReady() {

  // トップページの動画コンテナが存在: 切り替え用の動画プレーヤーをセットアップ
  if( document.getElementById(YTMOVIE_TOPPAGE_PLAYER_ID) ){
    // 初期表示の動画IDをHTMLから取得
    var firestMovieId = document.getElementById(YTMOVIE_TOPPAGE_PLAYER_ID).getAttribute('data-first-movieid');

    // 空のYTプレイヤーを生成
    yt_player = new YT.Player(YTMOVIE_TOPPAGE_PLAYER_ID, {
      height: '371',
      width: '660',
      videoId: firestMovieId,
      origin: location.protocol + '//' + location.hostname + "/",
      playerVars: {
        'rel': 0,             // 関連動画を同じチャンネルの動画に限定
        'modestbranding': 1   // コントローラ内のYTロゴを非表示
      },
      events: {
        'onReady': onPlayerReady_toppage,
        'onStateChange': onPlayerStateChange
      }
    });

  // 都道府県ページの動画iframeが存在: 動画プレーヤーをセットアップ
  }else if( document.getElementById(YTMOVIE_PREF_PLAYER_ID) ){
    // iframe用 の YTプレイヤーを生成
    yt_player = new YT.Player(YTMOVIE_PREF_PLAYER_ID, {
      origin: location.protocol + '//' + location.hostname + "/",
      playerVars: {
        'rel': 0,             // 関連動画を同じチャンネルの動画に限定
        'modestbranding': 1   // コントローラ内のYTロゴを非表示
      },
      events: {
        'onReady': onPlayerReady_pref,
        'onStateChange': onPlayerStateChange
      }
    });
  }
}

// callback: プレーヤーのセットアップ完了時(toppage/pref)
function onPlayerReady_toppage(event) {
  //  --- サイネージ表示時のみ動画を自動再生
  if(IS_SIGNAGE){
    event.target.playVideo();
  }
}

// callback: プレーヤーのセットアップ完了時(pref)
function onPlayerReady_pref(event) {
  //  --- サイネージ表示時のみ動画を自動再生
  if(IS_SIGNAGE){
    event.target.playVideo();
  }
}

// callback: プレーヤーの状態変更時(toppage/pref)
//  --- サイネージの時はループ再生する
var yt_loopCount = 0;
function onPlayerStateChange(event) {

  // 一般ページ: ループ再生しない
  if(IS_SIGNAGE === false){
    return;
  }

  // サイネージ: ループ再生: 動画再生終了時に動画の初めにシーク
  //   -- 2019.10.31 : 一時的にループ再生を止めるのでコメントアウト
  //   -- 2019.11.25 : 試験的に復帰
  if ( event.data == YT.PlayerState.ENDED) {
    if(yt_loopCount < YTMOVIE_LOOP_LIMIT_NUM) {         
      event.target.seekTo(0, true); 
      event.target.playVideo();
      yt_loopCount++;
    }
  }
}



// onclick(): 引数で渡された動画IDをロード
var yt_playing_videoid = "";
var playYTSelector = function (dataVideoid) {
  // 再生中の動画以外のサムネクリック時のみ動画をロードする
  if(yt_playing_videoid !== dataVideoid){
    yt_player.loadVideoById({ videoId: dataVideoid });
  }
  yt_playing_videoid = dataVideoid;  
};

// プレイヤーを一時停止: モーダルopen時などに呼び出す
var yt_PlayerState = "";
var pauseYTMovie = function () {
  if(yt_player){
    yt_PlayerState = yt_player.getPlayerState();
    yt_player.pauseVideo();
  }
};

// 一時停止した動画を再開: モーダルclose時に呼び出す
var restartYTMovie = function () {
  if(yt_player && ( yt_PlayerState === YT.PlayerState.PLAYING || yt_PlayerState === YT.PlayerState.BUFFERING) ){
    yt_player.playVideo();
  }
};

/*
    _wrap.start
*/

(function () {   //--- コーディングするコードを即時関数で囲んでスコープを切る

/**
 * main.js
 */
(function ($) {

  /****** Modaal ******/
  $('.js-modal').modaal({
    before_open: function() {
      pauseYTMovie();
    },
    after_close: function() {
      restartYTMovie();
    }
  });
  
  // 設定ボタン: a要素以外は都度定義が必要
  $('#js-settingBtn').modaal({
    content_source: '#js-settingModal',
    before_open: function() {
      pauseYTMovie();
    },
    after_close: function() {
      restartYTMovie();
    }
  });

  /****** ピックアップ動画: 一時停止の動画にアイコンをoverlay ******/
  $('.p-ytSelector__thumItem').on('click', function(){
    $('.p-ytSelector__thumItem').removeClass('js-ytSelector--playing');
    $(this).addClass('js-ytSelector--playing');

    setTimeout(function(){
      var playingPos = $('.js-ytSelector--playing').position();
      if(playingPos && playingPos.top){
        $(".p-ytSelector__thumList").animate({
          scrollTop: playingPos.top + $(".p-ytSelector__thumList").scrollTop()
        }, "slow", "swing");
      }else{
        $(".p-ytSelector__thumList").animate({ scrollTop: 0 }, 200, "swing");
      }
    }, 200);
  });


  /****** 北海道: 地図画像切り替え/拡大ボタン ******/
  // 拡大ボタン: 初期表示
  $('.p-prefHead__mapZoomBtn.js-modal-hokkaido').hide();
  $('.p-prefHead__mapZoomBtn.js-modal-hokkaido[href="map_image.png"]').show();

  // 地図画像切り替えボタン押下時
  $('.js-mapSelectorBtn').on('click', function(){

    // 切り替えボタン: data-view-image属性で指定した画像に表示を切り替え
    var vimage = $(this).attr('data-view-image');
    $('.p-prefHead__mapThumImage').attr('src', vimage);
    $('.js-mapSelectorBtn').removeClass('js-mapSelectorBtn--active');
    $(this).addClass('js-mapSelectorBtn--active');

    // 拡大ボタン: 5エリア分のボタンを一旦全表示消して、当該地図のボタンのみを再度表示
    $('.p-prefHead__mapZoomBtn.js-modal-hokkaido').hide();
    $('.p-prefHead__mapZoomBtn.js-modal-hokkaido[href="'+ vimage +'"]').show();
  });

  /****** 北海道: モーダル時 地図画像スライダー表示 ******/
  $('.p-prefHead__mapZoomBtn.js-modal-hokkaido').modaal({
    type: 'image',
    before_open: function() {
      pauseYTMovie();
    },
    after_close: function() {
      restartYTMovie();
    }
  });

  

  /****** 外部リンクを target="_blank" に切り替え ******/
  /*  アイコン表示時: CSSセレクタ [href^="http"]
      サイネージ表示時:  _blank には『しない』
      Vue配下のリンクや動的生成された要素については別実装が必要 */
  if(IS_SIGNAGE !== true){
    $('[href^="http"]').attr('target', '_blank');
  }else{
    $('html').addClass('js-view-signage');
  }
  
  /****** トップページ: YT動画ボックス高さ調整 ******/
  // ページ幅でSP判定
  var isSP = function(){
    return window.matchMedia('(max-width: 768px)').matches;
  }
  
  var ytSelectorResizeAction = function(){
    if( isSP() ){
      $('.p-ytSelector__thumList').attr('style', '');
    }else{
      //var bubHeight = $('.p-ytSelector__thumBox__caution').outerHeight();
      var movHeight = $('.p-ytSelector__movieBoxInner').outerHeight();
      $('.p-ytSelector__thumList').height(movHeight);
    }
  }
  ytSelectorResizeAction();
  $(window).on("resize", ytSelectorResizeAction);

  //test
  //$('#js-topInfoModal-button').trigger("click");


  /****** Button要素リンク: data-btnhref ******/

  // $('[data-btnhref]').on('click',function(){
  //   var hrefStr = $(this).attr('data-btnhref');
  //   location.href = hrefStr;

  // // TODO: GA組み込み
  // // TODO: サイネージ表示時のウィンドウ先

  //   // if(IS_SIGNAGE){
  //   //   // サイネージ表示時: 同じウィンドウ内で遷移
  //   //   location.href = hrefStr;
  //   // }else{
  //   //   // 一般表示時: 新しいウィンドウで表示
  //   //   window.open(hrefStr, '_blank');
  //   // }
  // });

  /****** TODO: 外部リンクを新しいウィンドウで表示（サイネージ除く） ******/

})(jQuery);



})();  //--- 即時関数によるスコープ: 終了

/*
    _wrap.end
*/
